import React from 'react';
import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';
import { Loader2, AlertCircle } from 'lucide-react';

const DEFAULT_COLORS = ['#0052FF', '#10B981', '#6366F1', '#F59E0B', '#EC4899', '#8B5CF6', '#14B8A6', '#F97316'];

const PieChartComponent = ({
  data = [],
  dataKey = 'value',
  nameKey = 'name',
  donut = true,
  colors = DEFAULT_COLORS,
  height = 300,
  loading = false,
  error = null,
  title = '',
  formatter = (v) => v,
  onSliceClick = null,
}) => {
  if (loading) {
    return (
      <div className="flex flex-col items-center justify-center bg-white border border-slate-200 rounded-xl p-6" style={{ height }}>
        <Loader2 className="w-8 h-8 animate-spin text-[#0052FF] mb-2" />
        <span className="text-xs text-slate-400 font-semibold uppercase tracking-wider">Loading Chart...</span>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex flex-col items-center justify-center bg-white border border-slate-200 rounded-xl p-6 text-center" style={{ height }}>
        <AlertCircle className="w-8 h-8 text-amber-500 mb-2" />
        <span className="text-xs text-slate-600 font-medium">{error}</span>
      </div>
    );
  }

  if (!data || data.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center bg-white border border-slate-200 rounded-xl p-6 text-center" style={{ height }}>
        <span className="text-xs text-slate-400 font-semibold uppercase tracking-wider">No Data Available</span>
      </div>
    );
  }

  return (
    <div className="bg-white border border-slate-200 rounded-xl p-5 shadow-sm space-y-3" data-testid="pie-chart-card">
      {title && <h4 className="text-xs font-bold text-slate-500 uppercase tracking-wider">{title}</h4>}
      <div style={{ width: '100%', height }}>
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Tooltip
              contentStyle={{ backgroundColor: '#0F172A', borderColor: '#334155', borderRadius: '8px', color: '#FFF', fontSize: '12px' }}
              formatter={(value, name) => [formatter(value), name]}
            />
            <Legend wrapperStyle={{ fontSize: '11px', paddingTop: '8px' }} />
            <Pie
              data={data}
              dataKey={dataKey}
              nameKey={nameKey}
              cx="50%"
              cy="50%"
              innerRadius={donut ? '55%' : 0}
              outerRadius="80%"
              paddingAngle={2}
              onClick={(entry) => onSliceClick && onSliceClick(entry)}
              className={onSliceClick ? 'cursor-pointer' : ''}
            >
              {data.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={colors[index % colors.length]} stroke="#FFF" strokeWidth={2} />
              ))}
            </Pie>
          </PieChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default PieChartComponent;
